import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { ANALYTICS_ACTION_CLICKED, ANALYTICS_SUBJECT_BUTTON, ButtonClickedEvent } from '@atlassian/mpac-analytics';
import { CANCEL_ABOUT_PARTNER_FORM, CANCEL_HOURS_OF_OPERATION_FORM, CANCEL_PARTNER_CONTACT_INFO_FORM, CANCEL_SUPPORT_CHANNELS_FORM, EDIT_ICON, MANAGE_PARTNER_DETAILS_VIEW, SUBMIT_ABOUT_PARTNER_FORM, SUBMIT_HOURS_OF_OPERATION_FORM, SUBMIT_PARTNER_CONTACT_INFO_FORM, SUBMIT_SUPPORT_CHANNELS_FORM } from '../../analytics/Events';
export const saveAboutPartnerFormAnalyticsConfig = {
  eventType: ButtonClickedEvent,
  eventContainer: MANAGE_PARTNER_DETAILS_VIEW,
  actionSubjectId: SUBMIT_ABOUT_PARTNER_FORM
};
export const cancelAboutPartnerFormAnalyticsConfig = {
  eventType: ButtonClickedEvent,
  eventContainer: MANAGE_PARTNER_DETAILS_VIEW,
  actionSubjectId: CANCEL_ABOUT_PARTNER_FORM
};
export const savePartnerContactFormAnalyticsConfig = {
  eventType: ButtonClickedEvent,
  eventContainer: MANAGE_PARTNER_DETAILS_VIEW,
  actionSubjectId: SUBMIT_PARTNER_CONTACT_INFO_FORM
};
export const cancelPartnerContactFormAnalyticsConfig = {
  eventType: ButtonClickedEvent,
  eventContainer: MANAGE_PARTNER_DETAILS_VIEW,
  actionSubjectId: CANCEL_PARTNER_CONTACT_INFO_FORM
};
export const saveHoursOfOperationFormAnalyticsConfig = {
  eventType: ButtonClickedEvent,
  eventContainer: MANAGE_PARTNER_DETAILS_VIEW,
  actionSubjectId: SUBMIT_HOURS_OF_OPERATION_FORM
};
export const cancelHoursOfOperationFormAnalyticsConfig = {
  eventType: ButtonClickedEvent,
  eventContainer: MANAGE_PARTNER_DETAILS_VIEW,
  actionSubjectId: CANCEL_HOURS_OF_OPERATION_FORM
};
export const saveSupportChannelsFormAnalyticsConfig = {
  eventType: ButtonClickedEvent,
  eventContainer: MANAGE_PARTNER_DETAILS_VIEW,
  actionSubjectId: SUBMIT_SUPPORT_CHANNELS_FORM
};
export const cancelSupportChannelsFormAnalyticsConfig = {
  eventType: ButtonClickedEvent,
  eventContainer: MANAGE_PARTNER_DETAILS_VIEW,
  actionSubjectId: CANCEL_SUPPORT_CHANNELS_FORM
};
export const editProfileDetailsIconAnalyticsConfig = attributes => ({
  eventContainer: MANAGE_PARTNER_DETAILS_VIEW,
  action: ANALYTICS_ACTION_CLICKED,
  actionSubject: ANALYTICS_SUBJECT_BUTTON,
  actionSubjectId: EDIT_ICON,
  attributes: _objectSpread({}, attributes)
});